import type { NodeTreeElement } from "./types.ts";

export const transformNodeSubtree = <TIn extends NodeTreeElement<any>, TOut extends NodeTreeElement<any>>(
  startNode: TIn,
  transform: (node: Omit<TIn, "childNodes" | "placeholder">) => Omit<TOut, "childNodes" | "placeholder">,
) => {
  const transformSubtree = ({ placeholder, childNodes, ...node }: TIn): TOut =>
    ({
      ...transform(node),
      childNodes: childNodes
        ? Object.fromEntries(
            Object.entries(childNodes).map(([name, childOrChildren]) => [
              name,
              Array.isArray(childOrChildren)
                ? childOrChildren.map(transformSubtree)
                : childOrChildren
                  ? transformSubtree(childOrChildren)
                  : undefined,
            ]),
          )
        : childNodes,
      placeholder: placeholder ? transformSubtree(placeholder) : undefined,
    }) as TOut;

  return transformSubtree(startNode);
};
